import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Translation resources
const resources = {
  en: {
    translation: {
      // Navigation
      "nav.aboutUs": "About Us",
      "nav.services": "Our Services",
      "nav.mediaPartners": "Media Partners",
      "nav.contact": "CONTACT US",
      
      // Hero
      "hero.title": "Your Web3 PR Hub in LATAM",
      "hero.subtitle": "We turn your announcements into real visibility across leading crypto media outlets.",
      "hero.telegram": "Telegram",
      "hero.email": "Email",
      "hero.note": "Need a quick reply? Chat with us on Telegram",
      
      // About
      "about.title": "About Us",
      "about.p1": "CryPT-BR helps Web3 projects break into LATAM's fast-growing crypto market.",
      "about.p2": "Through strategic press release distribution and localized storytelling, we ensure your announcements reach the right audience at the right time.",
      "about.p3": "We connect your project with LATAM crypto media, investors, builders, and communities — turning news into visibility, authority, and lasting impact.",
      
      // Media Coverage
      "mediaCoverage.title": "Trusted Media Coverage for Your Project",
      "mediaCoverage.desc": "From press releases and sponsored articles to organic PR campaigns, we manage everything from development to guaranteed placement across key media outlets",
      
      // Services
      "services.title": "Our Services",
      "service1.title": "Targeted Media Distribution",
      "service1.desc": "Strategic distribution across LATAM's top crypto media outlets to ensure your message reaches the right audience with maximum impact.",
      "service2.title": "Localised Messaging",
      "service2.desc": "Culturally-adapted content that resonates with LATAM audiences, combining global crypto trends with local market insights.",
      "service3.title": "Community Exposure",
      "service3.desc": "Direct access to LATAM's engaged Web3 communities, connecting your project with investors, builders, and early adopters.",
      "service4.title": "Blockchain-Focused PR",
      "service4.desc": "Specialized PR strategies tailored for blockchain projects, DeFi protocols, NFT launches, and Web3 innovations in the LATAM market.",
      "service5.title": "Shareable Micro Press Assets",
      "service5.desc": "High-impact, 30–40 second fully customized short videos designed for native distribution across X and social platforms.",
      "service6.title": "Banner Ads Placement",
      "service6.desc": "Targeted banner advertising on premium LATAM Web3, crypto, and blockchain platforms to drive traffic, visibility, and brand recognition.",
      
      // Media Partners
      "mediaPartners.title": "Our Media Partners",
      
      // Footer
      "footer.tagline": "LATAM's Web3 PR Gateway",
      "footer.contact": "Contact",
      "footer.telegram": "Telegram",
      "footer.email": "Email",
      "footer.linkedin": "LinkedIn"
    }
  },
  pt: {
    translation: {
      "nav.aboutUs": "Sobre Nós",
      "nav.services": "Nossos Serviços",
      "nav.mediaPartners": "Parceiros de Mídia",
      "nav.contact": "CONTATO",
      
      "hero.title": "Seu Hub de PR Web3 na LATAM",
      "hero.subtitle": "Transformamos seus anúncios em visibilidade real nos principais veículos de mídia cripto.",
      "hero.telegram": "Telegram",
      "hero.email": "Email",
      "hero.note": "Precisa de resposta rápida? Converse conosco no Telegram",
      
      "about.title": "Sobre Nós",
      "about.p1": "A CryPT-BR ajuda projetos Web3 a entrarem no mercado cripto da América Latina em rápido crescimento.",
      "about.p2": "Através de distribuição estratégica de press releases e storytelling localizado, garantimos que seus anúncios alcancem o público certo na hora certa.",
      "about.p3": "Conectamos seu projeto com mídia cripto da LATAM, investidores, construtores e comunidades — transformando notícias em visibilidade, autoridade e impacto duradouro.",
      
      "mediaCoverage.title": "Cobertura de Mídia Confiável para Seu Projeto",
      "mediaCoverage.desc": "De press releases e artigos patrocinados a campanhas de PR orgânico, gerenciamos tudo desde o desenvolvimento até a colocação garantida nos principais veículos de mídia",
      
      "services.title": "Nossos Serviços",
      "service1.title": "Distribuição de Mídia Direcionada",
      "service1.desc": "Distribuição estratégica nos principais veículos de mídia cripto da LATAM para garantir que sua mensagem alcance o público certo com máximo impacto.",
      "service2.title": "Mensagens Localizadas",
      "service2.desc": "Conteúdo culturalmente adaptado que ressoa com o público latino-americano, combinando tendências cripto globais com insights do mercado local.",
      "service3.title": "Exposição Comunitária",
      "service3.desc": "Acesso direto às comunidades Web3 engajadas da LATAM, conectando seu projeto com investidores, construtores e early adopters.",
      "service4.title": "PR Focado em Blockchain",
      "service4.desc": "Estratégias de PR especializadas para projetos blockchain, protocolos DeFi, lançamentos de NFT e inovações Web3 no mercado latino-americano.",
      "service5.title": "Micro Assets de Imprensa Compartilháveis",
      "service5.desc": "Vídeos curtos de alto impacto, de 30-40 segundos totalmente personalizados, projetados para distribuição nativa no X e plataformas sociais.",
      "service6.title": "Colocação de Anúncios em Banner",
      "service6.desc": "Publicidade em banner direcionada em plataformas premium de Web3, cripto e blockchain da LATAM para gerar tráfego, visibilidade e reconhecimento de marca.",
      
      "mediaPartners.title": "Nossos Parceiros de Mídia",
      
      "footer.tagline": "Portal de PR Web3 da LATAM",
      "footer.contact": "Contato",
      "footer.telegram": "Telegram",
      "footer.email": "Email",
      "footer.linkedin": "LinkedIn"
    }
  },
  es: {
    translation: {
      "nav.aboutUs": "Sobre Nosotros",
      "nav.services": "Nuestros Servicios",
      "nav.mediaPartners": "Socios de Medios",
      "nav.contact": "CONTACTO",
      
      "hero.title": "Tu Hub de PR Web3 en LATAM",
      "hero.subtitle": "Convertimos tus anuncios en visibilidad real en los principales medios de comunicación cripto.",
      "hero.telegram": "Telegram",
      "hero.email": "Email",
      "hero.note": "¿Necesitas una respuesta rápida? Chatea con nosotros en Telegram",
      
      "about.title": "Sobre Nosotros",
      "about.p1": "CryPT-BR ayuda a proyectos Web3 a ingresar al mercado cripto latinoamericano de rápido crecimiento.",
      "about.p2": "A través de distribución estratégica de comunicados de prensa y narración localizada, aseguramos que tus anuncios lleguen a la audiencia correcta en el momento correcto.",
      "about.p3": "Conectamos tu proyecto con medios cripto de LATAM, inversores, constructores y comunidades — convirtiendo noticias en visibilidad, autoridad e impacto duradero.",
      
      "mediaCoverage.title": "Cobertura de Medios Confiable para Tu Proyecto",
      "mediaCoverage.desc": "Desde comunicados de prensa y artículos patrocinados hasta campañas de PR orgánico, gestionamos todo desde el desarrollo hasta la colocación garantizada en los principales medios",
      
      "services.title": "Nuestros Servicios",
      "service1.title": "Distribución de Medios Dirigida",
      "service1.desc": "Distribución estratégica en los principales medios cripto de LATAM para asegurar que tu mensaje llegue a la audiencia correcta con máximo impacto.",
      "service2.title": "Mensajes Localizados",
      "service2.desc": "Contenido culturalmente adaptado que resuena con audiencias latinoamericanas, combinando tendencias cripto globales con perspectivas del mercado local.",
      "service3.title": "Exposición Comunitaria",
      "service3.desc": "Acceso directo a las comunidades Web3 comprometidas de LATAM, conectando tu proyecto con inversores, constructores y adoptadores tempranos.",
      "service4.title": "PR Enfocado en Blockchain",
      "service4.desc": "Estrategias de PR especializadas para proyectos blockchain, protocolos DeFi, lanzamientos de NFT e innovaciones Web3 en el mercado latinoamericano.",
      "service5.title": "Micro Activos de Prensa Compartibles",
      "service5.desc": "Videos cortos de alto impacto, de 30-40 segundos completamente personalizados, diseñados para distribución nativa en X y plataformas sociales.",
      "service6.title": "Colocación de Anuncios Banner",
      "service6.desc": "Publicidad banner dirigida en plataformas premium de Web3, cripto y blockchain de LATAM para generar tráfico, visibilidad y reconocimiento de marca.",
      
      "mediaPartners.title": "Nuestros Socios de Medios",
      
      "footer.tagline": "Portal de PR Web3 de LATAM",
      "footer.contact": "Contacto",
      "footer.telegram": "Telegram",
      "footer.email": "Email",
      "footer.linkedin": "LinkedIn"
    }
  },
  ru: {
    translation: {
      "nav.aboutUs": "О нас",
      "nav.services": "Наши услуги",
      "nav.mediaPartners": "Медиа-партнеры",
      "nav.contact": "КОНТАКТ",
      
      "hero.title": "Ваш Web3 PR-центр в LATAM",
      "hero.subtitle": "Мы превращаем ваши объявления в реальную видимость в ведущих криптомедиа.",
      "hero.telegram": "Telegram",
      "hero.email": "Email",
      "hero.note": "Нужен быстрый ответ? Напишите нам в Telegram",
      
      "about.title": "О нас",
      "about.p1": "CryPT-BR помогает Web3-проектам войти на быстрорастущий крипторынок Латинской Америки.",
      "about.p2": "Благодаря стратегическому распространению пресс-релизов и локализованному сторителлингу мы гарантируем, что ваши объявления достигнут нужной аудитории в нужное время.",
      "about.p3": "Мы связываем ваш проект с криптомедиа LATAM, инвесторами, разработчиками и сообществами — превращая новости в видимость, авторитет и долгосрочное влияние.",
      
      "mediaCoverage.title": "Надежное медиа-освещение для вашего проекта",
      "mediaCoverage.desc": "От пресс-релизов и спонсируемых статей до органических PR-кампаний, мы управляем всем от разработки до гарантированного размещения в ключевых медиа",
      
      "services.title": "Наши услуги",
      "service1.title": "Целевое медиа-распространение",
      "service1.desc": "Стратегическое распространение в топовых криптомедиа LATAM для максимального охвата целевой аудитории.",
      "service2.title": "Локализованные сообщения",
      "service2.desc": "Культурно адаптированный контент для латиноамериканской аудитории, сочетающий глобальные крипто-тренды с местными рыночными инсайтами.",
      "service3.title": "Охват сообщества",
      "service3.desc": "Прямой доступ к вовлеченным Web3-сообществам LATAM, связывая ваш проект с инвесторами, разработчиками и ранними последователями.",
      "service4.title": "PR для блокчейн-проектов",
      "service4.desc": "Специализированные PR-стратегии для блокчейн-проектов, DeFi-протоколов, запусков NFT и Web3-инноваций на рынке LATAM.",
      "service5.title": "Микро пресс-активы для распространения",
      "service5.desc": "Высокоэффективные короткие видео 30-40 секунд, полностью настроенные для нативного распространения в X и социальных платформах.",
      "service6.title": "Размещение баннерной рекламы",
      "service6.desc": "Целевая баннерная реклама на премиум-платформах Web3, крипто и блокчейн в LATAM для привлечения трафика, видимости и узнаваемости бренда.",
      
      "mediaPartners.title": "Наши медиа-партнеры",
      
      "footer.tagline": "Портал Web3 PR в LATAM",
      "footer.contact": "Контакт",
      "footer.telegram": "Telegram",
      "footer.email": "Email",
      "footer.linkedin": "LinkedIn"
    }
  },
  "zh-CN": {
    translation: {
      "nav.aboutUs": "关于我们",
      "nav.services": "我们的服务",
      "nav.mediaPartners": "媒体合作伙伴",
      "nav.contact": "联系我们",
      
      "hero.title": "您在LATAM的Web3公关中心",
      "hero.subtitle": "我们将您的公告转化为领先加密媒体的真实曝光。",
      "hero.telegram": "Telegram",
      "hero.email": "邮箱",
      "hero.note": "需要快速回复？在Telegram上与我们聊天",
      
      "about.title": "关于我们",
      "about.p1": "CryPT-BR帮助Web3项目进入拉丁美洲快速增长的加密市场。",
      "about.p2": "通过战略性新闻稿发布和本地化故事讲述，我们确保您的公告在正确的时间到达正确的受众。",
      "about.p3": "我们将您的项目与LATAM加密媒体、投资者、建设者和社区连接起来——将新闻转化为可见性、权威性和持久影响力。",
      
      "mediaCoverage.title": "值得信赖的媒体报道",
      "mediaCoverage.desc": "从新闻稿和赞助文章到有机公关活动，我们管理从开发到在关键媒体上保证投放的一切",
      
      "services.title": "我们的服务",
      "service1.title": "定向媒体分发",
      "service1.desc": "在LATAM顶级加密媒体上进行战略分发，确保您的信息以最大影响力触达正确的受众。",
      "service2.title": "本地化信息传递",
      "service2.desc": "文化适应性内容，与拉丁美洲受众产生共鸣，结合全球加密趋势与本地市场洞察。",
      "service3.title": "社区曝光",
      "service3.desc": "直接访问LATAM活跃的Web3社区，将您的项目与投资者、建设者和早期采用者联系起来。",
      "service4.title": "区块链专注公关",
      "service4.desc": "为LATAM市场的区块链项目、DeFi协议、NFT发布和Web3创新量身定制的专业公关策略。",
      "service5.title": "可分享微型新闻资产",
      "service5.desc": "高影响力的30-40秒完全定制短视频，专为X和社交平台的原生分发设计。",
      "service6.title": "横幅广告投放",
      "service6.desc": "在LATAM优质Web3、加密和区块链平台上投放定向横幅广告，以促进流量、可见性和品牌认知度。",
      
      "mediaPartners.title": "我们的媒体合作伙伴",
      
      "footer.tagline": "LATAM Web3公关门户",
      "footer.contact": "联系",
      "footer.telegram": "Telegram",
      "footer.email": "邮箱",
      "footer.linkedin": "LinkedIn"
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    lng: 'en',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

export default i18n;
